import { createApp } from "vue";
import { createPinia } from "pinia";
import Toast, { POSITION } from "vue-toastification";
import "vue-toastification/dist/index.css";
// Must run before anything renders the builder canvas: publishes the Nuxt
// auto-imports (ref/computed/useI18n/…) the real public-site block components
// rely on. See src/preview/nuxtShims.js.
import "./preview/nuxtShims";
import App from "./App.vue";
import router from "./router";
import NuxtLink from "./components/builder/NuxtLinkStub.vue";
import PhotoViewer from "./components/builder/PhotoViewerStub.vue";
import CanvasBlocks from "./components/builder/CanvasBlocks.vue";
// The real site header references <LanguageSwitcher> as a Nuxt global component;
// register it so the preview chrome (PreviewChrome → real SiteHeader) renders it.
import LanguageSwitcher from "~/components/LanguageSwitcher.vue";
import "./assets/main.css";
import "./assets/cms-content.css";

const toastOptions = {
  position: POSITION.TOP_RIGHT,
  timeout: 4000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  hideProgressBar: false,
  icon: true,
  maxToasts: 5,
  newestOnTop: true,
};

const app = createApp(App);
// Globally provide the components the public-site blocks expect by those names so
// they render unchanged in the live canvas: <NuxtLink>, the <PhotoViewer> lightbox
// stub, and <BlockRenderer> (which TwoColumnBlock recurses through — pointed at
// CanvasBlocks so nested blocks use the same single render path).
app.component("NuxtLink", NuxtLink);
app.component("PhotoViewer", PhotoViewer);
app.component("BlockRenderer", CanvasBlocks);
app.component("LanguageSwitcher", LanguageSwitcher);
app.use(createPinia());
app.use(router);
app.use(Toast, toastOptions);
app.mount("#app");
